<template>
  <!-- 头部整体盒子 -->
  <div id="header" class="container-fuild">
    <!-- 头部顶部 - 全宽背景，内容居中对齐导航 -->
    <div class="header-top hidden-xs">
      <div class="container clearfix" style="width: 85%">
        <div class="server pull-left">
          <span class="glyphicon glyphicon-earphone"></span>155 7630 1537
          <!-- <span class="glyphicon glyphicon-envelope"></span>xxx@163.com -->
          <span class="glyphicon glyphicon-time"></span>7x24小时为您服务
        </div>
        <div class="shejiao pull-right">
          <span class="glyphicon glyphicon-phone-alt"></span>
          <span>专业防水，随时咨询</span>
        </div>
      </div>
    </div>
    <!-- 电脑导航 -->
    <div class="header-nav hidden-xs">
      <div class="container clearfix header-nav-inner" style="width: 85%">
        <!-- 导航logo -->
        <div class="header-nav-logo pull-left">
          <router-link to="/" class="logo-text-link">
            <span class="logo-title">织歌</span>
            <span class="logo-subtitle">专注水泥级防水</span>
          </router-link>
        </div>
        <!-- 导航内容 -->
        <ul class="header-nav-wrapper pull-right">
          <li
            v-for="(item, index) in navList"
            :key="index"
            :class="{ active: index == navIndex }"
            @click="navClick(index, item.name)"
          >
            <router-link :to="item.path">
              {{ item.name }}
              <span v-if="item.children.length > 0" class="glyphicon glyphicon-menu-down"></span>
              <i class="underline"></i>
            </router-link>
            <dl v-if="item.children.length > 0">
              <dt v-for="(i, n) in item.children" :key="n">
                <router-link :to="i.path">{{ i.name }}</router-link>
              </dt>
            </dl>
          </li>
        </ul>
      </div>
    </div>
    <!-- 手机导航 -->
    <div class="header-nav-m container-fuild visible-xs">
      <div class="header-nav-m-logo">
        <router-link to="/" class="logo-text-link-m">
          <span class="logo-title-m">织歌</span>
          <span class="logo-subtitle-m">专注水泥级防水</span>
        </router-link>
      </div>
      <!-- 导航栏 -->
      <div class="header-nav-m-menu text-center">
        {{ menuName }}
        <div class="header-nav-m-menu-wrapper" @click="menuClick">
          <span :class="menuClass"></span>
        </div>
        <!-- 导航内容 -->
        <transition name="mobile-menu">
          <ul v-show="menuOpen" class="header-nav-m-wrapper">
            <li
              v-for="(item, index) in navList"
              :key="index"
              :class="{ active: index == navIndex }"
              @click="
                navClick(index, item.name);
                menuOpen = false;
              "
            >
              <router-link :to="item.path">
                {{ item.name }}
              </router-link>
            </li>
          </ul>
        </transition>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Header',
  data() {
    return {
      navIndex: sessionStorage.getItem('navIndex') ? sessionStorage.getItem('navIndex') : 0,
      menuName: '首页',
      menuClass: 'glyphicon glyphicon-menu-down',
      menuOpen: false,
      navList: [
        {
          name: '首页',
          path: '/',
          children: [],
        },
        // {
        //   name: "软件产品",
        //   path: "/software",
        //   children: [
        //     {
        //       name: "智能小镇管理系统",
        //       path: "/software/smartTown"
        //     },
        //     {
        //       name: "大数据管理系统",
        //       path: "/software/bigData"
        //     }
        //   ]
        // },

        {
          name: '公司服务',
          path: '/service',
          children: [],
        },
        {
          name: '公司动态',
          path: '/newsinformation',
          children: [],
        },
        {
          name: '公司介绍',
          path: '/companyintroduction',
          children: [],
        },
        // {
        //   name: "工作机会",
        //   path: "/jobchance",
        //   children: []
        // },
        // {
        //   name: "联系我们",
        //   path: "/contactus",
        //   children: []
        // }
      ],
    };
  },
  methods: {
    navClick(index, name) {
      this.navIndex = index;
      sessionStorage.setItem('navIndex', index);
      this.menuName = name;
    },
    menuClick() {
      this.menuOpen = !this.menuOpen;
      if (this.menuOpen) {
        this.menuClass = 'glyphicon glyphicon-menu-up';
      } else {
        this.menuClass = 'glyphicon glyphicon-menu-down';
      }
    },
  },
};
</script>
<style scoped>
/* ========================================
   整体
   ======================================== */
#header {
  background: #fff;
  transition: all ease 0.6s;
}

/* ========================================
   顶部条 - 背景全宽铺满，内容通过内层 .container 与导航对齐
   ======================================== */
#header .header-top {
  height: 50px;
  color: #ccc;
  font-size: 13px;
  line-height: 50px;
  background: #2c2c2c; /* 全宽深色背景 */
}
#header .header-top span {
  margin: 0 8px;
}
#header .header-top .shejiao {
  color: #aaa;
  letter-spacing: 1px;
}
#header .header-top .server .glyphicon,
#header .header-top .shejiao .glyphicon {
  color: #0d9e3c;
  margin: 0 4px;
}
#header .header-top .shejiao .glyphicon-phone-alt {
  margin-right: 6px;
}

/* ========================================
   电脑导航
   ======================================== */
#header .header-nav {
  /* 外层无容器约束，保持与 header-top 同级结构 */
}
#header .header-nav .header-nav-inner {
  height: 100px;
}

/* logo */
#header .header-nav .header-nav-logo {
  height: 100px;
  display: flex;
  align-items: center;
}
#header .header-nav .header-nav-logo .logo-text-link {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  padding: 10px 0;
  transition: opacity 0.3s ease;
}
#header .header-nav .header-nav-logo .logo-text-link:hover {
  opacity: 0.8;
}
#header .header-nav .header-nav-logo .logo-title {
  font-size: 32px;
  font-weight: 700;
  color: #2c2c2c;
  letter-spacing: 6px;
  line-height: 1.2;
}
#header .header-nav .header-nav-logo .logo-subtitle {
  font-size: 12px;
  font-weight: 400;
  color: #888;
  letter-spacing: 2px;
  line-height: 1.4;
  margin-top: 2px;
}

/* 导航列表 */
#header .header-nav .header-nav-wrapper {
  display: flex;
  align-items: center;
  margin: 0;
  padding: 0;
  list-style: none;
  gap: 4px;
  height: 100px;
}
#header .header-nav .header-nav-wrapper > li {
  position: relative;
}

/* 导航链接 */
#header .header-nav .header-nav-wrapper > li > a {
  display: block;
  color: #444;
  font-size: 15px;
  font-weight: 600;
  padding: 8px 18px;
  position: relative;
  text-decoration: none;
  transition: color 0.25s ease;
  letter-spacing: 0.5px;
}
#header .header-nav .header-nav-wrapper > li > a:hover {
  color: #0d9e3c;
}

/* 下划线 */
#header .header-nav .header-nav-wrapper > li > a > .underline {
  display: block;
  position: absolute;
  bottom: 0;
  left: 50%;
  width: 0;
  height: 2px;
  border-radius: 1px;
  opacity: 0;
  background: #0d9e3c;
  transition: all 0.3s ease;
}
/* hover 下划线展开 */
#header .header-nav .header-nav-wrapper > li > a:hover .underline {
  opacity: 1;
  width: calc(100% - 36px);
  left: 18px;
}

/* active 状态：无边框，仅文字变色 + 下划线常驻 */
#header .header-nav .header-nav-wrapper > li.active > a {
  color: #0d9e3c;
}
#header .header-nav .header-nav-wrapper > li.active > a .underline {
  opacity: 1;
  width: calc(100% - 36px);
  left: 18px;
}

/* 下箭头 */
#header .header-nav .header-nav-wrapper > li > a > span {
  font-size: 10px;
  margin-left: 4px;
  transition: transform 0.3s ease;
}
#header .header-nav .header-nav-wrapper > li:hover > a > span {
  transform: rotate(180deg);
}

/* ========================================
   二级下拉菜单
   ======================================== */
#header .header-nav .header-nav-wrapper > li > dl {
  display: none;
  position: absolute;
  width: 170px;
  top: 100%;
  left: 0;
  z-index: 9999;
  margin: 0;
  padding: 6px 0;
  background: #fff;
  border-radius: 6px;
  box-shadow: 0 6px 24px rgba(0, 0, 0, 0.1);
}
#header .header-nav .header-nav-wrapper > li:hover dl {
  display: block;
  animation: dropdownFadeIn 0.25s ease;
}
@keyframes dropdownFadeIn {
  from {
    opacity: 0;
    transform: translateY(-6px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
#header .header-nav .header-nav-wrapper > li > dl > dt {
  width: 100%;
  padding: 0;
}
#header .header-nav .header-nav-wrapper > li > dl > dt > a {
  display: block;
  padding: 10px 20px;
  color: #555;
  font-size: 14px;
  text-decoration: none;
  transition: all 0.2s ease;
}
#header .header-nav .header-nav-wrapper > li > dl > dt:hover {
  background: #f4fcf6;
}
#header .header-nav .header-nav-wrapper > li > dl > dt > a:hover {
  color: #0d9e3c;
}

/* ========================================
   手机导航
   ======================================== */
#header .header-nav-m {
  position: relative;
  background: #fff;
}

/* 手机 logo */
#header .header-nav-m .header-nav-m-logo {
  height: 70px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
}
#header .header-nav-m .header-nav-m-logo .logo-text-link-m {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-decoration: none;
}
#header .header-nav-m .header-nav-m-logo .logo-title-m {
  font-size: 24px;
  font-weight: 700;
  color: #2c2c2c;
  letter-spacing: 4px;
  line-height: 1.2;
}
#header .header-nav-m .header-nav-m-logo .logo-subtitle-m {
  font-size: 10px;
  font-weight: 400;
  color: #888;
  letter-spacing: 1px;
  line-height: 1.4;
  margin-top: 2px;
}

/* 手机菜单栏 */
#header .header-nav-m .header-nav-m-menu {
  height: 46px;
  line-height: 46px;
  font-size: 14px;
  font-weight: 600;
  color: #fff;
  background: #2c2c2c;
  position: relative;
  letter-spacing: 1px;
}

/* 汉堡按钮 */
#header .header-nav-m .header-nav-m-menu-wrapper {
  position: absolute;
  top: 50%;
  right: 16px;
  transform: translateY(-50%);
  width: 40px;
  height: 34px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 999;
}
#header .header-nav-m .header-nav-m-menu-wrapper span {
  color: #fff;
  font-size: 18px;
  transition: transform 0.25s ease;
}

/* 手机导航列表容器 */
#header .header-nav-m .header-nav-m-wrapper {
  position: absolute;
  top: 46px;
  left: 0;
  width: 100%;
  margin: 0;
  padding: 0;
  list-style: none;
  background: #fff;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.1);
  z-index: 999;
  overflow: hidden;
}
#header .header-nav-m .header-nav-m-wrapper > li {
  height: 48px;
  line-height: 48px;
  border-bottom: 1px solid #f0f0f0;
  transition: background 0.2s ease;
}
#header .header-nav-m .header-nav-m-wrapper > li:last-child {
  border-bottom: none;
}
#header .header-nav-m .header-nav-m-wrapper > li:hover {
  background: #f8fafb;
}
#header .header-nav-m .header-nav-m-wrapper > li > a {
  display: block;
  padding: 0 24px;
  color: #444;
  font-size: 15px;
  font-weight: 500;
  text-decoration: none;
  transition:
    color 0.25s ease,
    padding 0.25s ease;
}
#header .header-nav-m .header-nav-m-wrapper > li:hover > a {
  color: #0d9e3c;
  padding-left: 30px;
}

/* active */
#header .header-nav-m .header-nav-m-wrapper > li.active > a {
  color: #0d9e3c;
  font-weight: 600;
}

/* 手机菜单滑入/滑出动画 */
.mobile-menu-enter-active {
  transition: all 0.3s ease;
}
.mobile-menu-leave-active {
  transition: all 0.25s ease;
}
.mobile-menu-enter,
.mobile-menu-leave-to {
  opacity: 0;
  max-height: 0;
}
.mobile-menu-enter-to,
.mobile-menu-leave {
  max-height: 300px;
}

/* ========================================
   header nav fixed 兼容
   ======================================== */
#header .header-nav-fixed .header-nav-wrapper {
  line-height: 50px;
}

/* ========================================
   媒体查询
   ======================================== */
@media screen and (max-width: 997px) {
  #header .header-nav-m .header-nav-m-logo {
    height: 64px;
  }
  #header .header-nav-m .header-nav-m-logo .logo-title-m {
    font-size: 20px;
    letter-spacing: 3px;
  }
  #header .header-nav-m .header-nav-m-logo .logo-subtitle-m {
    font-size: 9px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue